export enum PriceInterval {
  once = 'once',
  week = 'week',
  month = 'month',
  auto = 'auto' // auto for auto detect posts -> auto-charge and auto-fill
}
